(function () {
  'use strict';
  if (window.PGCheckoutReferenceV144R2) return;
  window.PGCheckoutReferenceV144R2 = true;

  var ROOT_SELECTOR = '.cart_content, #pg-cart .pg-cart__summary';
  var CONTROL_SELECTOR = 'button, a, input[type="button"], input[type="submit"], [role="button"]';
  var PRIMARY = 'data-pg-checkout-main-v144-r2';
  var SKIP = 'data-pg-checkout-optout-v144-r2';
  var timer = null;

  function normal(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function caption(control) {
    return normal(control.innerText || control.textContent || control.value || control.getAttribute('aria-label'));
  }

  function isOptout(control) {
    var label = caption(control);
    return /continue\s+without(?:\s+checkout\s*\+)?/.test(label) ||
      control.matches('.onward-opt-out-link, [data-pg-onward-optout], .pg-onward-optout-link') ||
      control.hasAttribute(SKIP);
  }

  function excluded(control) {
    var label = caption(control);
    return isOptout(control) ||
      control.classList.contains('pg-cart-checkout-duplicate-v18') ||
      control.getAttribute('aria-hidden') === 'true' ||
      /view full cart|continue shopping|keep shopping|remove|delete|close cart|learn more|details|apple pay|google pay|shop pay|paypal|klarna/.test(label) ||
      control.matches('[data-pg-uk-native-generated="true"]');
  }

  function appContext(control, boundary) {
    for (var node = control; node && node !== boundary && node.nodeType === 1; node = node.parentElement) {
      var attrs = normal([node.id, typeof node.className === 'string' ? node.className : '', node.getAttribute('name')].join(' '));
      if (/onward|checkoutplus|checkout-plus|checkout_plus|checkout\s*\+/.test(attrs)) return true;
    }
    return false;
  }

  function rendered(control) {
    if (!control || !control.getBoundingClientRect) return false;
    var rect = control.getBoundingClientRect();
    if (rect.width <= 1 || rect.height <= 1) return false;
    if (typeof window.getComputedStyle !== 'function') return true;
    var style = window.getComputedStyle(control);
    return style.display !== 'none' && style.visibility !== 'hidden' &&
      parseFloat(style.opacity || '1') > 0.01;
  }

  function findPrimary(scope, controls) {
    var best = null;
    var score = -1;
    controls.forEach(function (control) {
      if (excluded(control)) return;
      var label = caption(control);
      var onward = appContext(control, scope);
      if (!onward && !/checkout\s*\+/.test(label)) return;
      if (!/checkout|payment|pay now/.test(label) && !control.matches('button[name="onward-checkout-btn__plus"]')) return;
      var points = 0;
      if (rendered(control)) points += 45;
      if (control.matches('button[name="onward-checkout-btn__plus"]')) points += 200;
      if (onward) points += 100;
      if (/checkout\s*\+/.test(label)) points += 60;
      if (/^secure checkout$/.test(label)) points += 35;
      if (control.matches('[data-minicart-checkout-button], .pg-cart__checkout-btn')) points -= 180;
      if (points > score) {
        score = points;
        best = control;
      }
    });
    return best;
  }

  function nativeFallback(scope) {
    var controls = scope.querySelectorAll('button[name="checkout"], button[data-minicart-checkout-button], button.pg-cart__checkout-btn');
    for (var i = 0; i < controls.length; i += 1) {
      var control = controls[i];
      if (!isOptout(control) && /checkout/.test(caption(control)) &&
          !control.classList.contains('pg-cart-checkout-duplicate-v18')) return control;
    }
    return null;
  }

  function syncScope(scope) {
    if (!scope) return;
    var controls = Array.prototype.slice.call(scope.querySelectorAll(CONTROL_SELECTOR));
    var optouts = controls.filter(isOptout);
    optouts.forEach(function (control) {
      if (!control.hasAttribute(SKIP)) control.setAttribute(SKIP, 'true');
      if (control.hasAttribute(PRIMARY)) control.removeAttribute(PRIMARY);
      if (control.getAttribute('aria-label') === 'Secure Checkout') control.removeAttribute('aria-label');
    });

    // Onward can decorate the existing main-cart button in place.
    // Prefer its real click target instead of a nested info link or a control
    // discovered before the add-on finishes hydrating.
    var decoratedMain = scope.closest && scope.closest('#pg-cart')
      ? scope.querySelector('button.pg-cart__checkout-btn.onward-checkout-btn')
      : null;
    var primary = decoratedMain && !isOptout(decoratedMain) && rendered(decoratedMain)
      ? decoratedMain
      : (findPrimary(scope, controls) || nativeFallback(scope));
    scope.querySelectorAll('[' + PRIMARY + ']').forEach(function (old) {
      if (old !== primary) old.removeAttribute(PRIMARY);
    });
    if (primary && !isOptout(primary)) {
      if (!primary.hasAttribute(PRIMARY)) primary.setAttribute(PRIMARY, 'true');
      if (primary.getAttribute('aria-label') !== 'Secure Checkout') {
        primary.setAttribute('aria-label', 'Secure Checkout');
      }
    }
  }

  function syncAll() {
    timer = null;
    document.querySelectorAll(ROOT_SELECTOR).forEach(syncScope);
  }

  function schedule(delay) {
    window.clearTimeout(timer);
    timer = window.setTimeout(syncAll, delay == null ? 20 : delay);
  }

  function init() {
    syncAll();
    ['cart:refresh', 'pg:cart-form-patched', 'pg:cart-synchronised', 'shopify:cart:lines-update'].forEach(function (name) {
      document.addEventListener(name, function () { schedule(30); });
    });
    document.addEventListener('click', function (event) {
      if (event.target && event.target.closest && event.target.closest(ROOT_SELECTOR)) schedule(100);
    }, true);
    if (window.MutationObserver && document.body) {
      new MutationObserver(function (mutations) {
        var relevant = mutations.some(function (mutation) {
          var target = mutation.target && mutation.target.nodeType === 1 ? mutation.target : mutation.target && mutation.target.parentElement;
          if (target && target.closest && target.closest(ROOT_SELECTOR)) return true;
          return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
            return node.nodeType === 1 && (node.matches && node.matches(ROOT_SELECTOR) ||
              node.querySelector && node.querySelector(ROOT_SELECTOR));
          });
        });
        if (relevant) schedule(40);
      }).observe(document.body, { childList: true, characterData: true, subtree: true });
    }
    [100, 400, 1100, 2400, 5500].forEach(function (delay) {
      window.setTimeout(syncAll, delay);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();